import {
  footInMeter,
  inchInMillimeter,
  inchSquaredInQuadratmillimeter,
  kiloNewtonDividedByMetreSquaredInPoundPerSquaredInchIn,
  kilonewtonInKilopound,
  kilonewtonProQuadratmeterInKilopoundPerSquareFoot,
  kilopoundInKilonewton,
  kilopoundPerSquareFootInKilonewtonProQuadratmeter,
  kilopoundPerSquareInchInMegapscal,
  megapscalInKilopoundPerSquareInch,
  meterInFoot,
  millimeterInInch,
  poundPerSquaredInchInKiloNewtonDividedByMetreSquared,
  quadratmillimeterInInchSquared,
} from "../../../services/imperialMetricKonverter.service";
import { ImperialUnits, MetricUnits } from "../Units/AllUnits";
import Foot from "../Units/Imperial/Foot";
import Inch from "../Units/Imperial/Inch";
import InchSquared from "../Units/Imperial/InchSquared";
import Kilopound from "../Units/Imperial/Kilopound";
import KilopoundPerSquaredFoot from "../Units/Imperial/KilopoundPerSquaredFoot";
import KilopoundPerSquareInch from "../Units/Imperial/KilopoundPerSquareInch";
import PoundPerSquaredInch from "../Units/Imperial/PoundPerSquaredInch";
import KiloNewton from "../Units/Metric/KiloNewton";
import KiloNewtonDividedByMetreSquared from "../Units/Metric/KiloNewtonDividedByMetreSquared";
import Megapascal from "../Units/Metric/Megapascal";
import Metre from "../Units/Metric/Metre";
import Millimetre from "../Units/Metric/Millimetre";
import MillimetreSquared from "../Units/Metric/MillimetreSquared";

export const ConversionList = [
  //#region Imperial => Metric
  { from: ImperialUnits.Foot, to: MetricUnits.Metre, convert: footInMeter },
  {
    from: ImperialUnits.Inch,
    to: MetricUnits.Millimetre,
    convert: inchInMillimeter,
  },
  {
    from: ImperialUnits.InchSquared,
    to: MetricUnits.MillimetreSquared,
    convert: inchSquaredInQuadratmillimeter,
  },
  {
    from: ImperialUnits.Kilopound,
    to: MetricUnits.KiloNewton,
    convert: kilopoundInKilonewton,
  },
  {
    from: ImperialUnits.KilopoundPerSquaredFoot,
    to: MetricUnits.KiloNewtonDividedByMetreSquared,
    convert: kilopoundPerSquareFootInKilonewtonProQuadratmeter,
  },
  {
    from: ImperialUnits.KilopoundPerSquareInch,
    to: MetricUnits.Megapascal,
    convert: kilopoundPerSquareInchInMegapscal,
  },
  {
    from: ImperialUnits.PoundPerSquaredInch,
    to: MetricUnits.KiloNewtonDividedByMetreSquared,
    convert: poundPerSquaredInchInKiloNewtonDividedByMetreSquared,
  },
  // #endregion

  //#region  Metric => Imperial
  { from: MetricUnits.Metre, to: ImperialUnits.Foot, convert: meterInFoot },
  {
    from: MetricUnits.Millimetre,
    to: ImperialUnits.Inch,
    convert: millimeterInInch,
  },
  {
    from: MetricUnits.MillimetreSquared,
    to: ImperialUnits.InchSquared,
    convert: quadratmillimeterInInchSquared,
  },
  {
    from: MetricUnits.KiloNewton,
    to: ImperialUnits.Kilopound,
    convert: kilonewtonInKilopound,
  },
  {
    from: MetricUnits.KiloNewtonDividedByMetreSquared,
    to: ImperialUnits.KilopoundPerSquaredFoot,
    convert: kilonewtonProQuadratmeterInKilopoundPerSquareFoot,
  },
  {
    from: MetricUnits.Megapascal,
    to: ImperialUnits.KilopoundPerSquareInch,
    convert: megapscalInKilopoundPerSquareInch,
  },
  {
    from: MetricUnits.KiloNewtonDividedByMetreSquared,
    to: ImperialUnits.PoundPerSquaredInch,
    convert: kiloNewtonDividedByMetreSquaredInPoundPerSquaredInchIn,
  },
  // #endregion
];

export const ElementUnit = [
  // -------------Imperial-------------
  {
    unit: ImperialUnits.Foot,
    element: <Foot />,
  },
  {
    unit: ImperialUnits.Inch,
    element: <Inch />,
  },
  {
    unit: ImperialUnits.InchSquared,
    element: <InchSquared />,
  },
  {
    unit: ImperialUnits.Kilopound,
    element: <Kilopound />,
  },
  {
    unit: ImperialUnits.KilopoundPerSquaredFoot,
    element: <KilopoundPerSquaredFoot />,
  },
  {
    unit: ImperialUnits.KilopoundPerSquareInch,
    element: <KilopoundPerSquareInch />,
  },
  {
    unit: ImperialUnits.PoundPerSquaredInch,
    element: <PoundPerSquaredInch />,
  },
  // -------------Metric-------------
  {
    unit: MetricUnits.Metre,
    element: <Metre />,
  },
  {
    unit: MetricUnits.Millimetre,
    element: <Millimetre />,
  },
  {
    unit: MetricUnits.MillimetreSquared,
    element: <MillimetreSquared />,
  },
  {
    unit: MetricUnits.KiloNewton,
    element: <KiloNewton />,
  },
  {
    unit: MetricUnits.KiloNewtonDividedByMetreSquared,
    element: <KiloNewtonDividedByMetreSquared />,
  },
  {
    unit: MetricUnits.Megapascal,
    element: <Megapascal />,
  },
];
